import { func, string, oneOf } from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Close } from '@styled-icons/evil/Close';

const SCloseIcon = styled(Close)`
  display: none;
  color: ${(props) => (props.mode === 'dark' ? 'white' : 'inherit')};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.phablet}) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    cursor: pointer;
  }
`;

const CloseIcon = ({ handleClose, alt }) => (
  <SCloseIcon onClick={handleClose} size={60} alt={alt} />
);

export default withTheme(CloseIcon);

CloseIcon.propTypes = {
  handleClose: func.isRequired,
  alt: string.isRequired,
  mode: oneOf(['light', 'dark']),
};

CloseIcon.defaultProps = {
  mode: 'light',
};
